const commonConstants = {
	minPermanentSideMenuWidth: 800,
	adminDrawerWidth: 240,
	doNotShowSideMenuFor: ["/registracija"],
	googleMapsApiKey: "AIzaSyDcoTlpd8bB1hIx--7lRQ4enXSzPHyTW6g",
	myProfilePathNameEnd: "mano", // for /paskyros/:maybeId where maybeId = {myProfilePathNameEnd}
};

export { commonConstants };
